<div *ngIf="isOpen" class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4"
  (click)="onBackdropClick()">
  <div class="bg-white rounded-3xl max-w-md w-full shadow-2xl overflow-hidden transform transition-all duration-300"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1.5 w-full bg-gradient-to-r from-[#D31148] to-[#ff6b9d]"></div>

    <div class="px-7 py-7">

      <!-- Icon -->
      <div class="flex justify-center mb-5">
        <div class="w-16 h-16 rounded-full bg-[#FFF0F3] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" stroke="#D31148" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <line x1="4" y1="22" x2="4" y2="15" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-center text-xl font-bold text-gray-900 mb-2">Report this {{ targetLabel }}</h3>
      <p class="text-center text-sm text-gray-500 leading-relaxed mb-5">
        Tell us what's wrong. Our team will review it and take action if it breaks our community guidelines.
      </p>

      <!-- Description textarea -->
      <textarea
        [(ngModel)]="description"
        [maxlength]="maxLength"
        [disabled]="isSubmitting"
        rows="4"
        placeholder="Describe the issue (e.g. spam, harassment, inappropriate content)…"
        class="w-full resize-none rounded-xl border border-gray-200 px-4 py-3 text-sm text-gray-800 placeholder:text-gray-400
               focus:outline-none focus:ring-2 focus:ring-[#D31148]/30 focus:border-[#D31148] disabled:bg-gray-50"
      ></textarea>
      <div class="mt-1 mb-4 text-right text-xs text-gray-400">{{ description.length }}/{{ maxLength }}</div>

      <p *ngIf="errorMessage" class="mb-4 text-sm text-center text-red-500">{{ errorMessage }}</p>

      <!-- Buttons -->
      <div class="flex flex-col gap-3">
        <button (click)="onSubmit()" [disabled]="!description.trim() || isSubmitting"
          class="w-full py-3 rounded-xl bg-[#D31148] text-white font-semibold text-sm
                 hover:bg-[#b80e3d] active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isSubmitting ? 'Submitting…' : 'Submit Report' }}
        </button>
        <button (click)="onCancel()" [disabled]="isSubmitting"
          class="w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm
                 hover:bg-gray-50 active:scale-[0.98] transition-all disabled:opacity-50">
          Cancel
        </button>
      </div>

    </div>
  </div>
</div>
